import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useImperativeHandle,
} from 'react';
import { Form, Input, Spin, Row, Col, Skeleton, Button, Checkbox } from 'antd';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import Email from '@/components/H5PC/Form/Email';
import getTypeByPattern from '@/components/Common/getTypeByPattern.js';
import { infoCb } from '@/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import { getDomainFromUrlStr, getDomainStr } from '@/components/H5PC/utils'
import CPF from '@/components/H5PC/Components/CPF';
import myContext from '@/utils/createContext';
import { getUrlParams, gtag, arraysHaveCommonValues } from '@/utils/index.js';
import Address from '@/components/H5PC/Form/Address';

const FormItem = Form.Item;

const key = getUrlParams('key'); // 从 URL 中获取 key

function PIXBOL(props) {
  const nameOnCardRef = useRef();
  const addressRef = useRef();
  const intl = props.intl;
  const { formatMessage } = intl;
  // radioValue 即为LCR 或者 ICR
  const { form, initData, resData, cashierData, radioValue, isMobileView, type, loading, setLoading, actualPaymentAmount,
    actualPaymentCurrency, } = useContext(
    myContext,
    );
  console.log(cashierData, 'cashierData', type);
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  let showDomain = '';
  if(typeof window!= 'undefined' && getDomainFromUrlStr()){
    showDomain = getDomainStr(resData)
  }
  let [activeLoading, setActiveLoading] = useState(true);

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [hasTerms, setHasTerms] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(cashierData)) {
      setTimeout(() => {
        setActiveLoading(false);
      }, 10);
      // 判断是否需要显示条款
      const payments = cashierData?.payments;

      payments.map((item, key) => { 
        if (item?.paymentMethod === type.toUpperCase() && arraysHaveCommonValues(['Llbr-pix', 'Llbr-boleto'], item?.channelCodes)) { 
          setHasTerms(true)
        }
      })
    }
    setButtonDisabled(sessionStorage.getItem('buttonDisabled') === 'true' ? true : false)
  }, [cashierData]);
  const onBlurCardName = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入持卡人姓名']);
    gtag(`${showDomain}支付页面`, ['输入持卡人姓名']);
    showDomain ? gtag(`定制支付页面`, ['输入持卡人姓名']):'';
    
  };
  // todo 111，专门传递address组件中的信息而存在的
  useImperativeHandle(props.cref, () => ({
    // 动态改变label的值
    clickEdit: () => {
      setAddressChange(addressRef);
    },
  }));

  // 表单验证错误，弹出地址选择信息
  const setAddressChange = cref => {
    if (!_.isEmpty(cref.current)) {
      cref.current.clickEdit();
    }
  };
  // todo 222，专门传递address组件中的信息而存在的

  return (
    <Skeleton
      loading={activeLoading}
      active={true}
      title={false}
      // style={{ padding: 100 }}
      paragraph={{ rows: 7 }}
    >
      {radioValue === 'PIX' || radioValue === 'BOL' ? (
        <>
          <Row gutter={20} style={{ marginBottom: '-10px', padding: '0 15px' }}>
            <Col span={24}>
              <FloatLabel
                extra={<div style={{ marginBottom: form.getFieldValue('cardName')? 0 : 16}}>{formatMessage({ id: 'ga-checkout.new-full-name-extraTip' })}</div>}
                form={form}
                name="cardName"
                cref={nameOnCardRef}
                // label="Full Name"
                //formatMessage({ id: 'ga-checkout.sailor-payer-name' })
                label={cashierData?.merchantSourceType === "SAILOR"?formatMessage({ id: 'ga-checkout.sailor-payer-name' }):formatMessage({ id: 'ga-checkout.new-full-name' })}
                rules={[
                  {
                    required: true,
                    // message: `Please enter your full name.`,
                    message: cashierData?.merchantSourceType === "SAILOR"?formatMessage({ id: 'ga-checkout.sailor-payer-name' }):formatMessage({id: 'ga-checkout.new-please-enter-full-name'}),
                  },
                  ({ getFieldValue }) => ({
                    validator: async (rule, value) => {                  
                      if (_.isEmpty(value)) return;
                      let _lang = localStorage.getItem('locale')
                      if (_lang === 'pt-BR' || _lang === 'en-US') {
                        const eleArray = value.split(/[\s\n]/);                      
                        if(_.uniq(eleArray).length !== eleArray.length){
                          return Promise.reject(
                            formatMessage({
                              id: 'ga-checkout.name-repeat-tip',
                            }),
                          );
                        }                        
                      }                   
                    },
                  }),
                ]}
              >
                <Input
                  size="large"
                  maxLength={128}
                  onBlur={e => onBlurCardName(e)}
                />
              </FloatLabel>
            </Col>
          </Row>

          {/* CPF */}
          <myContext.Provider
            value={{
              form,
              isMobileView,
              radioValue,
              showDomain,
              initData,
              resData,
              cashierData,
            }}
          >
            <CPF />
          </myContext.Provider>
          <myContext.Provider
            value={{ initData, cashierData, form, radioValue, isMobileView, showDomain }}
          >
            <Address cref={addressRef} type={type}/>
          </myContext.Provider>

          <myContext.Provider value={{ form, cashierData, isMobileView, showDomain }}>
            <Email />
          </myContext.Provider>
          { 
            hasTerms ?
              <div className='pixBol-terms'>
                <Checkbox
                  onChange={() => {
                    setButtonDisabled(!buttonDisabled)
                    sessionStorage.setItem('buttonDisabled', !buttonDisabled)
                  }}
                  checked={!buttonDisabled}
                >
                  {formatMessage({ id: 'ga-checkout.brazil-i-agree-with' })}
                  <a target='_blank' href='https://www.lianlianglobal.com.br/termos-de-uso.html'>
                    {formatMessage({ id: 'ga-checkout.brazil-terms-of-us' })}
                  </a>
                  {formatMessage({ id: 'ga-checkout.brazil-and-the' })}
                  <a target='_blank' href="https://www.lianlianglobal.com.br/politica-de-privacidade.html">
                    {formatMessage({ id: 'ga-checkout.brazil-privacy-policy' })}
                  </a>
                  {formatMessage({ id: 'ga-checkout.brazil-of-lianlian-pay' })}
                </Checkbox>
              </div>
              :
              null
          }
          
          <div className="h5pc-submit">
            <Button
              className="h5pc-submit-btn"
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={buttonDisabled}
            >

              <span className="lock-img" ></span>
              {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
              {actualPaymentAmount} {actualPaymentCurrency}
            </Button>
          </div>
          {radioValue === 'PIX' && (cashierData?.merchantSourceType === "SAILOR")?<div style={{
            fontSize:'14px',
            padding:'0 20px'
          }}>
            <p style={{
              color:'#00000073',
              lineHeight:'20px',
              marginBottom:'0.5em'
            }}>{formatMessage({id: 'ga-checkout.pix.tip1' })}</p>
            <p style={{
              color:'#00000073',
              lineHeight:'20px',
              marginBottom:'0.5em'
            }}>{formatMessage({id: 'ga-checkout.pix.tip2' })}</p>
            <p style={{
              color:'#00000073',
              lineHeight:'20px',
              marginBottom:'0.5em'
            }}>{formatMessage({id: 'ga-checkout.pix.tip3' })}</p>
          </div> : ""}
        </>
      ) : null}
    </Skeleton>
  );
}

export default injectIntl(PIXBOL);
